export default __webpack_public_path__ + "static/media/SmsConfig.b2ce0580.svg";